import { favOptions } from "./Faves.js"
import { useState } from "react";
import SearchingNavbar from "./SearchingNavbar.js";
import Modal from './Modal.js';

// READ
// movies variable has an id property in case you needed for modal

export default function FavoritesPage() {
    let movies = favOptions("GET");
    const [isHidden, setIsHidden] = useState(true);
    const [movieModal, setMovieModal] = useState(null);
    const [searchInput, setSearchInput] = useState('');

    function handleOpenModal() {
        setIsHidden(false);
    }    

    const handleModal = ({ key }) => {
        handleOpenModal();
        setMovieModal(movies[key]);
    }
    console.log("TOT", movies)

    const searchRequest = () => {
        //add search bar functionality here later
    };

    return (
        <div className="main-content">
            <SearchingNavbar/>
            <div className="landing-page">
                <Modal isHidden={isHidden} setIsHidden={setIsHidden} movieModal={movieModal} setMovieModal={setMovieModal} />
                <h1 className="fav-header text-white">Your Favorites</h1>
                <div className="fav-holder wrap">
                    {   
                        Object.keys(movies).map(function(key) {
                            return (<div className="fav-movies movie-holder m-2 w-1 h-100" style={{background: `url(https://image.tmdb.org/t/p/w300/${movies[key].path})`}} onClick={() => handleModal({ key })}>
                            </div>)
                        })
                    }
                </div>
            </div>
        </div>
    )
}

// console.log(movies)
// return (
//     <div className="favoritesHolder">
//         {movies.map(function(key, val) {
//             return <div style={{background: `url(${val.path})`}} key={`${key}}`}></div>
//         })}
//     </div>
// )